<template>
    <router-view />
</template>

<script>
    // https://deepinder.me/creating-a-real-time-chat-app-with-vue-socket-io-and-nodejs
    import SocketioService from './services/socketio.service'

    export default {
        name: 'App',
        components: {},
        created() {
            SocketioService.setupSocketConnection()
        },
        beforeUnmount() {
            SocketioService.disconnect()
        }        
    }
</script>

<style>
</style>